"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var FloatingLabels = /** @class */ (function () {
    function FloatingLabels() {
        var _a;
        this.forms = document.querySelectorAll("[".concat(constants_1.DATA_FLOATING_LABEL_FORM, "]"));
        if (!(this.forms.length > 0))
            return;
        (_a = this.forms) === null || _a === void 0 ? void 0 : _a.forEach(function (form) {
            var formFields = form.querySelectorAll(constants_1.DATA_FORM_ELEMENTS);
            if (!(formFields.length > 0))
                return;
            formFields.forEach(function (formField) {
                FloatingLabels.onChange(formField);
                formField.addEventListener('click', function () { return FloatingLabels.onChange(formField); });
                formField.addEventListener('keyup', function () { return FloatingLabels.onChange(formField); });
            });
        });
    }
    FloatingLabels.onChange = function (element) {
        var value = element.value;
        if (!value)
            return;
        if (value.trim().length) {
            element === null || element === void 0 ? void 0 : element.classList.add(constantsClasses_1.CLASS_FILLED);
        }
        else {
            element === null || element === void 0 ? void 0 : element.classList.remove(constantsClasses_1.CLASS_FILLED);
        }
    };
    return FloatingLabels;
}());
exports.default = FloatingLabels;
